import { ContactSupportContent } from "@/app/services/context/ContactSupportContent";

const ContactUs = () => {
  return <ContactSupportContent variant="modal" />;
};

export default ContactUs;
